import React from 'react'
import { Box, Container, Paper, Stack, Text } from '@mantine/core'
import { IconClock, IconLock, IconUser } from '@tabler/icons-react'
import SectionHeader from './shared/SectionHeader'
import { BRAND_COLOR, STORAGE_CONTENT, USAGE_CONTENT } from '../utils/constants'

export default function StorageAndUsage() {
  return (
    <Box id="usage" py={{ base: 60, md: 100 }} style={{ backgroundColor: '#F5F7FA' }}>
      <Container size="xl">
        <Stack gap={60}>
          <Box>
            <SectionHeader badge={STORAGE_CONTENT.badge} title={STORAGE_CONTENT.title} centered />

            <Paper
              p="xl"
              radius="lg"
              mt={40}
              style={{
                backgroundColor: '#FFFFFF',
                border: '1px solid #E5E7EB',
              }}
            >
              <Stack gap="lg">
                <Box style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>
                  <Box
                    style={{
                      width: 48,
                      height: 48,
                      borderRadius: '12px',
                      backgroundColor: `${BRAND_COLOR}12`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                    }}
                  >
                    <IconClock size={24} color={BRAND_COLOR} />
                  </Box>
                  <Box>
                    <Text size="md" c="#1F2329" fw={600} mb="xs">
                      有限期保存
                    </Text>
                    <Text size="sm" c="#4B5563" style={{ lineHeight: 1.7 }}>
                      {STORAGE_CONTENT.description}
                    </Text>
                  </Box>
                </Box>

                <Box
                  p="md"
                  style={{
                    borderRadius: 12,
                    backgroundColor: '#F8FAFC',
                    border: '1px solid #E5E7EB',
                  }}
                >
                  <Text size="sm" c="#4B5563" fw={500} mb="sm">
                    保存内容仅供：
                  </Text>
                  <Stack gap="xs">
                    {STORAGE_CONTENT.points.map((point, index) => (
                      <Box key={index} style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                        <IconUser size={16} color={BRAND_COLOR} />
                        <Text size="sm" c="#4B5563">
                          {point}
                        </Text>
                      </Box>
                    ))}
                  </Stack>
                </Box>

                <Box
                  p="md"
                  style={{
                    borderRadius: 12,
                    backgroundColor: `${BRAND_COLOR}08`,
                    border: `1px solid ${BRAND_COLOR}15`,
                  }}
                >
                  <Box style={{ display: 'flex', gap: 8, alignItems: 'flex-start' }}>
                    <IconLock size={16} color={BRAND_COLOR} style={{ marginTop: 2, flexShrink: 0 }} />
                    <Text size="sm" c="#4B5563" style={{ lineHeight: 1.6 }}>
                      {STORAGE_CONTENT.note}
                    </Text>
                  </Box>
                </Box>
              </Stack>
            </Paper>
          </Box>

          <Box>
            <SectionHeader badge={USAGE_CONTENT.badge} title={USAGE_CONTENT.title} centered />

            <Paper
              p="xl"
              radius="lg"
              mt={40}
              style={{
                backgroundColor: '#FFFFFF',
                border: '1px solid #E5E7EB',
              }}
            >
              <Stack gap="md">
                <Text size="md" c="#4B5563" style={{ lineHeight: 1.8, textAlign: 'center' }}>
                  {USAGE_CONTENT.description}
                </Text>
                <Box
                  p="md"
                  style={{
                    borderRadius: 12,
                    backgroundColor: '#FEF3C7',
                    border: '1px solid #FCD34D',
                  }}
                >
                  <Text size="sm" c="#92400E" fw={500} style={{ textAlign: 'center' }}>
                    {USAGE_CONTENT.note}
                  </Text>
                </Box>
              </Stack>
            </Paper>
          </Box>
        </Stack>
      </Container>
    </Box>
  )
}
